import type { FC } from 'react';

import { PublicLayout, StatusInfoTypes } from '@catalyze/ui';
import { StyledStatusInfoModal } from 'features/CreatePassword/components/StatusMessages/styled';
import {
    FormSubtitle,
    FormTitle,
} from 'features/SignUp/components/FormTitle/styled';
import { Navigation } from 'features/SignUp/components/Navigation';

export const SignUpApproval: FC = () => {
    return (
        <PublicLayout navigation={Navigation}>
            <StyledStatusInfoModal type={StatusInfoTypes.SUCCESS} bigPadding>
                <FormTitle>
                    We will get in touch to activate your account
                </FormTitle>
                <FormSubtitle>
                    You can finish your registration within 30 days by visiting
                    Complete your registration link in the email we just sent
                    you
                </FormSubtitle>
            </StyledStatusInfoModal>
        </PublicLayout>
    );
};
